import React from "react";
import SaleReport from "../modules/SaleReport";

export default function SaleReportPage() {
    return <SaleReport/>
}